import React, { Component } from "react";
import styled, { css } from "styled-components";
//import { observable } from "mobx";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { graphql, compose } from "react-apollo";
//import moment from "moment";
//import { Config } from "constant";
import { ShowNotice } from "Store";
import { queryGetMe, mutationUpdateAgentManagement } from "Apollo";
//import { Scrollbars } from "react-custom-scrollbars";
//import Button from "module-common/Button";
import { store, ResetInput } from "./store";
import Avatar from "module-common/Avatar";
import LabelList from "module-common/label-list/LabelList";
import Panel from "./Panel";
import Input from "./Input";
import Image from "./Image";
import Tooltip from "module-common/Tooltip";
import IconRaw from "module-common/Icon";
import Header from "./header/HeaderWithStoreQuery";
import Filter from "./filter/FilterWithStore";
import List from "./list/ListWithStoreQuery";
import moment from "moment";
import PickDateTime from "./PickDateTime";
import { Config } from "constant";
import {
  queryGetChannels,
  mutationAddSchedulerPost,
  mutationUpdateSchedulerPost
} from "../Apollo";
import ChannelLimit from "./ChannelLimit";
import { Button } from "antd/lib/radio";
import index from "antd/lib/version";
import PostTo from "./PostTo";

export default compose(
  graphql(queryGetMe, { name: "agent" }),
  graphql(mutationUpdateAgentManagement),
  graphql(queryGetChannels),
  graphql(mutationAddSchedulerPost, { name: "mutateAddPostScheduler" }),
  graphql(mutationUpdateSchedulerPost, { name: "mutateUpdatePostScheduler" })
)(
  observer(
    class ModuleSchedule extends Component {
      onSelect = value => {
        // Cek Sudah ada di array atau belum
        if (
          !store.selectedChannel.find(function(obj) {
            return obj.companyChannelHandler == value.id;
          })
        ) {
          let specificId;
          if (value.channel.name === "twitter") {
            specificId = 1;
          } else {
            specificId = 3;
          }
          store.companyChannelHandlerList.push({
            companyChannelHandler: value.id,
            name: value.name
          });

          store.selectedChannel.push({
            channelId: value.channel.id,
            companyChannelHandler: value.id,
            specificType: specificId
          });

          store.selectedChannelStyle = true;
          store.selectedChannelId = value.id;
        } else {
          // Kalau sudah ada di array
          let temp = [];
          store.selectedChannel.forEach(item => {
            if (item.companyChannelHandler != value.id) {
              temp.push({
                channelId: item.channelId,
                companyChannelHandler: item.companyChannelHandler,
                specificType: item.specificType
              });
            }
          });
          store.selectedChannel = temp;
          store.selectedChannelStyle = false;
          store.selectedChannelId = 0;
        }
      };

      getDateTime = fromChild => {
        store.selectedValue = fromChild;
      };

      onImageUpload = event => {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);

        fetch(`${Config.apiUrl}/upload`, {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: formData
        })
          .then(response => response.text())
          .then(url => {
            store.imageUrl = url;
          });
      };

      render() {
        const content = store.content;
        const selectedChannel = toJS(store.selectedChannel);
        const companyChannelHandlerList = toJS(store.companyChannelHandlerList);
        const getChannel = this.props.data.getCompanyChannelHandler;
        const list = getChannel ? getChannel : [];

        let limit;
        if (store.selectedChannel.length > 0) {
          limit = 0;
          store.selectedChannel.forEach(item => {
            let temp;
            if (item.specificType === 1) {
              temp = 280;
            } else {
              temp = 2000;
            }
            if (limit === 0) {
              limit = temp;
            } else if (temp < limit) {
              limit = temp;
            }
          });
          limit = limit - content.length;
        }

        let listFilter;
        listFilter = list.filter(item => item.channel.name !== "instagram");

        const Accounts = props => {
          return (
            <Account
              key={"account" + props.id}
              onClick={() => this.onSelect(props.row)}
            >
              {/* {this.state.selectedChannelStyle &&
              this.state.selectedChannelId === props.id
                ? "active"
                : null} */}
              <LeftColumn>
                <StyledAvatar image={props.image} channel={props.channel} />
              </LeftColumn>
              <RightColumn>
                <Username>{props.displayname}</Username>
                <LabelList />
              </RightColumn>
            </Account>
          );
        };

        const companyChannelHandler = listFilter.map((row, index) => {
          const channel = row.channel.name;
          if (channel === "twitter" || channel === "facebook") {
            return (
              <Accounts
                key={index}
                id={row.id}
                image={row.displayPicture}
                channel={row.channel.name}
                displayname={row.displayName}
                row={row}
              />
            );
          }
        });

        return (
          <Wrapper>
            <Border width={"calc(30vh)"}>
              <Panel title="POST">
                <Title>Choose your account: </Title>
                <WrapperAccount>{companyChannelHandler}</WrapperAccount>
              </Panel>
              <WrapperPost>
                <Wrap>
                  <TextArea>
                    <Input
                      placeholder="Type your post here"
                      value={content}
                      onChange={text => (store.content = text)}
                    />
                  </TextArea>
                  <PostTo
                    channel={selectedChannel}
                    companyChannelHandler={companyChannelHandlerList}
                  />
                </Wrap>

                <Bottom>
                  <ChannelLimit channel={selectedChannel} limit={limit} />

                  <LeftBottom>
                    {store.imageUrl === null ? (
                      ""
                    ) : (
                      <Image
                        url={store.imageUrl}
                        onRemove={() => (store.imageUrl = null)}
                      />
                    )}
                  </LeftBottom>

                  <RightBottom>
                    <div>
                      <label htmlFor="file">
                        <Tooltip text="Upload Image">
                          <Icon
                            name="image-off-gray"
                            width={19.5}
                            height={19.5}
                            nameSelected="image-selected"
                          />
                        </Tooltip>
                      </label>
                      <HiddenFileInput
                        id="file"
                        onChange={this.onImageUpload}
                      />
                    </div>
                    <PickDateTime
                      text="Datetime"
                      onClick={this.onClick}
                      position="bottom"
                      value={store.selectedValue}
                      dateTime={fromChild => this.getDateTime(fromChild)}
                    >
                      <Icon
                        name="calendar-off"
                        width={20}
                        height={20}
                        nameSelected="calendar-selected"
                      />
                    </PickDateTime>
                  </RightBottom>
                  <SendButton onClick={this.onSend}>SEND</SendButton>
                </Bottom>
              </WrapperPost>
            </Border>
            <Border width={"calc(50vh)"}>
              <WrapperSchedule>
                <Header />
                <Filter key="filter" store={store} />
                <List key="list" />
              </WrapperSchedule>
            </Border>
          </Wrapper>
        );
      }

      onSend = async () => {
        const {
          mutateAddPostScheduler,
          mutateUpdatePostScheduler
        } = this.props;
        const {
          content,
          updateId,
          selectedValue,
          selectedChannel,
          imageUrl
        } = toJS(store);

        try {
          if (updateId === -1) {
            await mutateAddPostScheduler({
              variables: {
                postInput: selectedChannel,
                content: content,
                dateForPost: moment(selectedValue),
                image: imageUrl
              }
            });
          } else {
            await mutateUpdatePostScheduler({
              variables: {
                PostInput: selectedChannel,
                content: content,
                dateForPost: moment(selectedValue),
                image: imageUrl,
                SchedulerInputId: updateId
              }
            });
          }

          ResetInput();

          // onConfirm();
          ShowNotice("scheduled-post-add-success");
        } catch (e) {
          ShowNotice("scheduled-post-add-error");
        }
      };
    }
  )
);

const Wrapper = styled.section`
  flex: 1;
  display: flex;
  flex-direction: row;
  box-shadow: none;
  background-color: #ebeef7;
  margin: -10px;
`;
const WrapperPost = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  margin: 5px 20px 10px;
`;
const WrapperSchedule = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-right: 1px solid ${props => props.theme.panelBorder};
`;
const Border = styled.div`
  display: flex;
  flex: 1;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${props => props.theme.panelBackground};
  box-shadow: ${props => props.theme.shadow};
  margin: 10px;
  flex-direction: column;
  ${props => props.width && css`width: ${props.width};`}
`;
const WrapperAccount = styled.div`
  display: flex;
  margin-left: 10px;
  overflow-x: scroll;
`;


const Account = styled.div`
  display: flex;
  min-width: 120px;
  min-height: 30px;
  border-radius: 4px;
  /* border: 1px solid ${props => props.theme.panelBorder};
  background-color: #ebeef7; */
  margin-bottom: 8px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    border: 1px solid ${props => props.theme.blueButton};
  }
  ${props => {
    if (props.selectedChannelStyle) {
      return css`
        border: 1px solid ${props => props.theme.blueButton};
        background-color: #fff;
      `;
    } else {
      return css`
        border: 1px solid ${props => props.theme.panelBorder};
        background-color: #ebeef7;
      `;
    }
  }};
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 30px;
  align-items: center;
  padding: 3px 20px 3px 20px;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 0 10px;
`;
const StyledAvatar = styled(Avatar)`
  width: 30px;
  height: 30px;
`;
const Username = styled.div`
  line-height: 1.2;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.65);
`;
const Title = styled.div`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
  padding-left: 20px;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  padding: 0 16px;
  align-items: space-between;
`;
const Signature = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  margin-left: 4px;
  margin-top: 18px;
  margin-right: 20px;
`;
const Icon = styled(IconRaw)`
  margin-right: 10px;
`;
const SendButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: 20px;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 5px 15px;
  margin-left: 10px;
  background-color: ${props => props.theme.blueButton};
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const HiddenFileInput = styled.input.attrs({
  type: "file",
  accept: "image/*"
})`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const Wrap = styled.section`
  position: relative;
  display: inline-block;
`;
const Span = styled.span`
  color: #338dca;
`;
const TextArea = styled.section`
  padding-top: 30px;
`;
const LeftBottom = styled.div`
  display: flex;
  margin-left: auto;
`;
const RightBottom = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/module-schedule/ModuleScheduleWithQueryMutation.js